import React, { useCallback } from 'react';
import { FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import clsx from 'clsx';
import { CreateBookingFormV4 } from '../../../../services/create-booking-v4/schema/CreateBookingSchemaV4';
import { toast } from 'sonner';

interface GuestInfoPropsV4 {
    index: number;
    register: UseFormRegister<CreateBookingFormV4>;
    errors: FieldErrors<CreateBookingFormV4>;
    watch: UseFormWatch<CreateBookingFormV4>;
    setValue: UseFormSetValue<CreateBookingFormV4>;
}

const GuestInfoV4: React.FC<GuestInfoPropsV4> = ({ index, register, errors, watch, setValue }) => {

    // BARU: Fungsi untuk menyalin data dari kontak utama
    const handleCopyFromMainContact = useCallback(() => {
        // Ambil nama dari kamar pertama (yang dianggap sebagai kontak utama)
        const mainFirstName = watch('bookingroom.0.customer_name');
        const mainLastName = watch('bookingroom.0.customer_surname');
        const mainEmail = watch('bookingroom.0.customer_email');

        if (!mainFirstName && !mainLastName && !mainEmail) {
            toast.warning("Main contact info is empty.");
            return;
        }

        // Set nilai untuk kamar saat ini, dan tandai sebagai "dirty"
        setValue(`bookingroom.${index}.customer_name`, mainFirstName || '', { shouldDirty: true, shouldValidate: true });
        setValue(`bookingroom.${index}.customer_surname`, mainLastName || '', { shouldDirty: true, shouldValidate: true });
        setValue(`bookingroom.${index}.customer_email`, mainEmail || '', { shouldDirty: true, shouldValidate: true });

        toast.info("Main contact info has been copied to this room.");

    }, [index, watch, setValue]);

    return (
        <div className="col-sm-4 ps-0 ps-sm-4">
            <div className="col-12">
                <div className="d-flex justify-content-between align-items-center">
                    <label className="col-form-label">Guest's First Name:</label>
                    {/* Tombol "Copy" hanya muncul untuk kamar kedua dst. */}
                    {index > 0 && (
                        <button type="button" className="btn btn-link btn-sm p-0" onClick={handleCopyFromMainContact}>
                            Use Main Guest's Info
                        </button>
                    )}
                </div>
                <input
                    type="text"
                    placeholder="First Name"
                    className={clsx('form-control', { 'is-invalid': errors.bookingroom?.[index]?.customer_name })}
                    {...register(`bookingroom.${index}.customer_name`)}
                />
                {errors.bookingroom?.[index]?.customer_name && <div className="invalid-feedback">{errors.bookingroom[index].customer_name.message}</div>}
            </div>
            <div className="col-12">
                {/* PERBAIKAN: Label diubah */}
                <label className="col-form-label">Guest's Last Name:</label>
                <input
                    type="text"
                    placeholder="Last Name"
                    className="form-control"
                    {...register(`bookingroom.${index}.customer_surname`)}
                />
            </div>
            <div className="col-12">
                <label className="col-form-label">Email:</label>
                <input
                    type="email"
                    placeholder="Email"
                    className={clsx('form-control', { 'is-invalid': errors.bookingroom?.[index]?.customer_email })}
                    {...register(`bookingroom.${index}.customer_email`)}
                />
                {errors.bookingroom?.[index]?.customer_email && <div className="invalid-feedback">{errors.bookingroom[index].customer_email.message}</div>}
            </div>
        </div>
    );
};

export default GuestInfoV4;